import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Collapse } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";

const PersonaSelectionComponent = ({
  options,
  handleCheckChange,
  selectedPersonaNames,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // console.log('persona==>', options)

  // Function to handle click outside the component
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Form ref={ref}>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="default"
        style={{
          backgroundColor: "white",
          width: "100%",
          height: "50px",
          padding: "11.5px 10px",
          border: "0.4px solid lightgrey",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1rem",
            fontWeight: "360",
          }}
        >
          <span>
            {selectedPersonaNames.length !== 0 ? (
              <>
                {selectedPersonaNames.length === 1 ? (
                  <span> {selectedPersonaNames[0]} </span>
                ) : (
                  <span> ({selectedPersonaNames.length}) selected </span>
                )}
              </>
            ) : (
              <>Select Personas</>
            )}
          </span>
          <FaAngleDown
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0)", // Rotate the icon based on the dropdown state
              transition: "transform 0.3s ease-in-out", // Add transition for smooth animation
            }}
          />
        </div>
      </Button>
      <Collapse
        style={{
          position: "absolute",
          backgroundColor: "white",
          width: "230px",
          zIndex: 1,
        }}
        in={open}
      >
        <div id="example-collapse-text">
          <Form.Group controlId="exampleForm.SelectCustom">
            {options &&
              options.length !== 0 &&
              options.map((option) => (
                <Form.Check
                  style={{ fontSize: "0.85rem", fontWeight: "600" }}
                  key={option.id}
                  type="checkbox"
                  label={option?.persona?.name}
                  className={`mb-2 customData`}
                  checked={selectedPersonaNames.includes(option?.persona?.name)}
                  onChange={(event) => handleCheckChange(option?.persona?.name)}
                />
              ))}
          </Form.Group>
        </div>
      </Collapse>
    </Form>
  );
};

export default PersonaSelectionComponent;
